export default __webpack_public_path__ + "static/media/Standard25.bd287e45.png";